import { Box } from "@mui/material"
import useTranslationSharie from "../hooks/Language/useTranslation"

const SharieLegend = (props) => {
  const { payload } = props
  const t = useTranslationSharie()
  return (
    <Box display='flex' justifyContent='center' gap={2} mt={2}>
      {payload.map((entry, index) => (
        <Box key={index} display='flex' alignItems='center'>
          {/* Rainbow Gradient Color Box */}
          <Box
            sx={{
              width: 16,
              height: 16,
              borderRadius: 2,
              marginRight: 1,
              backgroundImage:
                "linear-gradient(90deg, red, orange, yellow, green, blue, indigo, violet)",
            }}
          />
          {/* Legend Label */}
          <span style={{ color: "black", fontWeight: "bold", fontSize: "16px" }}>
            {t("Prefrences")}
          </span>
        </Box>
      ))}
    </Box>
  )
}
export default SharieLegend
